module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_sapporo@3x-78440cb64aa01b7ebdb241a400e8c815.webp";